module.exports = __webpack_public_path__ + "vue-dist/img/verify-passed.4d358ad8.png";